// const Login = () => import(/* webpackChunkName: "Login" */'../components/account/Login')
const Login = load('account/Login')
const Account = load('account/Account')
const Dashboard = load('account/Dashboard')
const Orders = load('account/Orders')
const Favorites = load('account/UserFavorites')
const BuyAgain = load('account/BuyAgain')
const GuestFavorites = load('account/GuestFavorites')
const ForgotPassword = load('account/ForgotPassword')
const ResetPassword = load('account/ResetPassword')
const DigitalLibary = load('account/DigitalLibary')
const Subscriptions = load('account/Subscriptions')
const UpdateSubscription = load('subscription/checkout/UpdateSubscription')
const CreateAccount = load('account/CreateAccount')
const SingleOrder = load('account/SingleOrder')
import store from '../store'
import { load } from './component-loader'

const initialTitle = " | Eichlers  ";
export default [
      {
        path:'/login',
        name:'Login',
        component:Login,
        meta:{title:'Login' + initialTitle},
        beforeEnter(to,from,next){  
          if(from.name === "SignIn"){
            next({name:"SignIn"});
          }
          else if(!store.getters['customer/isAuth']){
            next();
          }
          else{
            next({name:"Home"})
          }
        }
      },
      {
        path:"/register",
        name:"CreateAccount",
        component:CreateAccount,
        meta:{title:'Create Account' + initialTitle},
      },
      {
        path:"/forgot-password",
        name:"ForgotPassword",
        component:ForgotPassword,
        meta:{title:'Forgot Password' + initialTitle},
        beforeEnter(to,from,next){       
          if(!store.getters['customer/isAuth']){
            next();
          }
          else{
            next({name:"Home"})
          }
        }
      },
      {
        path:"/password/reset/:token",
        name:"ResetPassword",
        component:ResetPassword,
        meta:{title:'Reset Password' + initialTitle},
        beforeEnter(to,from,next){       
          if(!store.getters['customer/isAuth']){
            next();
          }
          else{
            next({name:"Home"})
          }
        }
      },
      {
        path:'/account',
        name:'Account',
        component:Account,
        meta:{title:'Account' + initialTitle},
        redirect:{name:"Dashboard"},
        beforeEnter(to,from,next){
          if(!store.getters['customer/isAuth']){ 
            localStorage.setItem("prevUrl",to.path);      
            next({name:'Login'})
          }else{next();}
        },
        children:[
          {
            name:"Dashboard",
            path:"dashboard",
            component:Dashboard,
            meta:{title:'Dashboard' + initialTitle}
          },
          {
            name:"Orders",
            path:"orders",
            component:Orders,
            meta:{title:'Orders' + initialTitle}
          },
          {
            name:"SingleOrder",
            path:"orders/:id",
            component:SingleOrder,
            meta:{title:'Orders' + initialTitle}
          },
          {
            name:"Favorites",
            path:"favorites",
            component:Favorites,
            meta:{title:'Favorites' + initialTitle}
          },
          {
            name:"BueAgain",
            path:"buy-it-again",
            component:BuyAgain,
            meta:{title:'Buy it again' + initialTitle}
          },
          {
            path:"digital-libary",
            name:"DigitalLibary",
            component:DigitalLibary,
            meta:{title:'Digital Libary' + initialTitle}
          },
          {
            path:"subscriptions",
            name:"Subscriptions",
            component:Subscriptions,
            meta:{title:'Subscriptions' + initialTitle}
          },
          {
            path:"subscriptions-update/:subscription_id",
            name:"UpdateSubscription",
            component:UpdateSubscription,
            meta:{title:'Update Subscription' + initialTitle}
          }
        ]
      },
      {
        name:"GuestFavorites",
        path:"/favorites",
        component:GuestFavorites,
        meta:{title:'Favorites' + initialTitle},
        beforeEnter(to,from,next){
          if(store.getters['customer/isAuth']){
            next({name:'Favorites'})
          }else{
            next();
          }
        }
      }
]


// WEBPACK FOOTER //
// ./resources/js/router/account.js